import { v4 as uuidv4  } from "uuid";

export enum AssessmentStatus {
  DRAFT = 0,
  ARCHIVED = 1,  
  PUBLISHED = 2,
}

export interface Item {
  id: string;
  type: number;
  title: any;
  description: any;
  resources: string[];
  marks?: number;
  required?: boolean;
}


export interface TheoryQuestion extends Item {
  rules: any[]
}

export interface ObjectiveQuestion extends Item {
  options: any[];
  shuffle_options: boolean;
  correct_answer: string[]
}


export const newSubHeader = (): Item => ({
  id: uuidv4(),
  type: 0,
  title: null,
  description: null,
  resources: []
});

export const newTheoryQuestion = (): TheoryQuestion => ({
  id: uuidv4(),
  type: 0,
  title: null,
  description: null,
  resources: [],
  marks: 1,
  rules: [""]
});

export const newObjectiveQuestion = (): ObjectiveQuestion => ({
  id: uuidv4(),
  type: 0,
  title: null,
  description: null,
  resources: [],
  marks: 1,
  correct_answer: [],
  options: ["Option 1"],
  shuffle_options: true
});

export const newFileUploadQuestion = (): Item => ({
  id: uuidv4(),
  type: 0,
  title: null,
  description: null,
  resources: [],
  marks: 1
});

export function createItemByType(type: number): Item {
  switch (type) {
    case 0:
      return newSubHeader();

    case 1:
    case 2:
      return { ...newTheoryQuestion(), type };

    case 3:
    case 4:
      return { ...newObjectiveQuestion(), type };

    case 5:
      return newFileUploadQuestion();

    default:
      throw new Error(`Unknown item type: ${type}`);
  }
}


export interface Assessment {
  id: number;
  title: string;
  instruction: any;
  timer: boolean;
  duration: number;
  auto_marker: boolean;
  shuffle_questions: boolean;
  default_marks: number;
  show_score: boolean;
  show_summary: boolean;
  multiple_submissions: boolean;
  questions: Item[][];
  last_updated: string;
  classroom_id: number;
  status: AssessmentStatus,
  responses: any[] | null
}

export const newAssessment = (): Assessment => ({
  id: 0,
  title: '',
  instruction: null,
  timer: false,
  duration: 0,
  auto_marker: false,
  shuffle_questions: false,
  default_marks: 1,
  show_score: true,
  show_summary: false,
  multiple_submissions: false,
  questions: [[{
      ...newSubHeader(),
      title: {
          "type": "paragraph",
          "content": [
              {
                  "text": `Section 1`,
                  "type": "text",
                  "marks": [
                      {
                          "type": "bold"
                      }
                  ]
              }
          ]
      }
  }]],
  last_updated: '',
  classroom_id: 0,
  status: AssessmentStatus.DRAFT,
  responses: []
});

export function createAssessmentPayload(assessment: Assessment, classroom_id: number) {
  return {
    title: assessment.title,
    timer: assessment.timer,
    duration: assessment.duration,
    auto_marker: assessment.auto_marker,
    multiple_submissions: false,
    questions: assessment.questions,
    classroom_id: classroom_id
  };
}

export function updatedAssessmentPayload(
  assessment: Assessment,
  classroom_id: number
) {
  return {
    id: assessment.id,
    title: assessment.title,
    instruction: assessment.instruction,
    duration: assessment.duration,
    auto_marker: assessment.auto_marker,
    default_marks: assessment.default_marks,
    shuffle_questions: assessment.shuffle_questions,
    show_score: assessment.show_score,
    show_summary: assessment.show_summary,
    multiple_submissions: assessment.multiple_submissions,
    questions: assessment.questions,
    classroom_id,
  };
}
